import { Region } from 'pages/Map/types';
import { MapSearchResult, SearchItem } from 'pages/MapSearch/types';
import { Dispatch, MutableRefObject, SetStateAction } from 'react';

export type SearchMetaData = {
    id: string;
    searchTime: number;
    searchString: string;
};
export type ZoneResult = {
    [searchItemId: string]: SearchItem;
};
export type ZoneWiseResult = {
    [zone: string]: ZoneResult;
};
export type MapSearchContextType = {
    isMapSearch: boolean;
    setIsMapSearch: Dispatch<SetStateAction<boolean>>;
    zoneWiseResult: ZoneWiseResult;
    setSearchResult: (region: Region, searchResult: MapSearchResult | undefined) => ZoneWiseResult;
    activeSearchId: string | undefined;
    setActiveSearchId: (id?: string) => void;
    resetSearch: () => void;
    closeSearch: () => void;
    searchMetaData: MutableRefObject<SearchMetaData>;
};

export const enum SearchStatus {
    SEARCH_ACTIVE = 'search_active',
    SEARCH_FOUND = 'search_found'
}
